import React, { useState, useRef, useEffect } from "react";
import * as S from "./styles";
import { AnswerDataProps, CardProps, InputTypes, SectionProps } from "../../store";
import { linkify } from "../Utils/linkify";

const ResultSection = ({
  section,
  answerData,
  teamNumber,
}: {
  section: SectionProps;
  answerData: AnswerDataProps | undefined;
  teamNumber: number;
}) => {
  const isAddableSection = () => {
    if (section.teamNumber === undefined) return false;

    return section.teamNumber > 1;
  };

  // teamIndex 가 teamNumber 이면서 cardIdsInSection 에 있는 answer
  const hasTeamNumberAnswer = () => {
    const cardIdsInSection = section.cards.map((card) => card.id);

    const answer = answerData?.answerSnippets.find(
      (snippet) =>
        snippet.teamIndex === teamNumber && cardIdsInSection.includes(snippet.formCardId),
    );

    if (answer === undefined) return false;

    return true;
  };

  const hasAnswer = (cardId: string) => {
    const answer = answerData?.answerSnippets.find(
      (snippet) => snippet.formCardId === cardId && snippet.teamIndex === teamNumber,
    );
    return answer !== undefined;
  };

  const findAnswer = (cardId: string) => {
    const answer = answerData?.answerSnippets.find(
      (snippet) => snippet.formCardId === cardId && snippet.teamIndex === teamNumber,
    );
    return answer?.answer?.split("[-sep-]") ?? [];
  };

  const findUrl = (cardId: string) => {
    const answer = answerData?.answerSnippets.find(
      (snippet) => snippet.formCardId === cardId && snippet.teamIndex === teamNumber,
    );
    return answer?.url?.split("[-sep-]");
  };

  const removeNullAnswer = (answer: string) => (answer === "null" ? "" : answer);

  if (isAddableSection() && !hasTeamNumberAnswer()) return null;

  return (
    <S.Container>
      {isAddableSection() && (
        <span
          style={{
            cursor: "pointer",
            color: "blue",
            padding: "10px 0 0px 15px",
            marginBottom: "10px",
            display: "inline-block", // 또는 "block"
          }}
        >
          {` 팀원 ${teamNumber + 1}`}
        </span>
      )}
      {section.cards.map((card) => (
        <S.ResultContainer>
          <S.Card>
            <S.ResultTitleSection>
              <S.TitleSection>
                <S.Title>{card.cardTitle}</S.Title>
                {card.isRequired ? <S.RequireMark>*</S.RequireMark> : null}
              </S.TitleSection>
            </S.ResultTitleSection>
            <S.ResultAnswerSection>
              {/* eslint-disable-next-line no-nested-ternary */}
              {card.inputType !== InputTypes.FILE ? (
                !hasAnswer(card.id) ? (
                  <S.NoTextAnswer> </S.NoTextAnswer>
                ) : (
                  <>
                    {findAnswer(card.id)!.map((answer) => (
                      <S.TextAnswer>{linkify(removeNullAnswer(answer))}</S.TextAnswer>
                    ))}
                  </>
                )
              ) : null}
              {/* eslint-disable-next-line no-nested-ternary */}
              {card.inputType === InputTypes.FILE ? (
                !hasAnswer(card.id) ? (
                  <S.NoTextAnswer> </S.NoTextAnswer>
                ) : (
                  <>
                    {/* <S.UrlAnswer>파일명</S.UrlAnswer> */}
                    {findAnswer(card.id)!.map((answer) => (
                      <S.ListAnswer>{answer}</S.ListAnswer>
                    ))}
                    {/* <S.UrlAnswer>다운로드 경로</S.UrlAnswer> */}
                    {findUrl(card.id)!.map((url) => (
                      <S.ListAnswer>
                        <S.Url href={url} target="_blank" rel="noopener noreferrer">
                          [첨부파일 다운로드 받기]
                        </S.Url>
                      </S.ListAnswer>
                    ))}
                    <p style={{ color: "red", fontSize: "12px", paddingTop: "20px" }}>
                      첨부파일은 개인정보이기에 링크를 외부에 복사붙혀넣기하거나 공유하면 절대
                      안됩니다. 사용자 정보보호에 유의해주세요
                    </p>
                  </>
                )
              ) : null}
            </S.ResultAnswerSection>
          </S.Card>
        </S.ResultContainer>
      ))}
    </S.Container>
  );
};

export default ResultSection;
